const STORAGE_KEY = 'pendingLogEntry'
const LOG_CACHE_KEY = 'sessionLogCache'
const MAX_CACHED_LOGS = 1000

function isLogEntry(entry) {
  return Boolean(entry && entry.source && entry.time && entry.content)
}

export function appendPendingLogEntry(entry) {
  if (!isLogEntry(entry)) return

  const pendingEntries = readStoredEntries(STORAGE_KEY)
  pendingEntries.push(entry)
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(pendingEntries))

  const cachedLogs = readStoredEntries(LOG_CACHE_KEY)
  cachedLogs.push(entry)
  writeCachedLogs(cachedLogs)
}

export function readCachedLogs() {
  return readStoredEntries(LOG_CACHE_KEY)
}

export function cacheLogs(entries) {
  if (!Array.isArray(entries)) return
  writeCachedLogs(entries.filter(isLogEntry))
}

function readStoredEntries(key) {
  try {
    const storedValue = sessionStorage.getItem(key)
    const parsedValue = storedValue ? JSON.parse(storedValue) : []
    return Array.isArray(parsedValue)
      ? parsedValue.filter(isLogEntry)
      : isLogEntry(parsedValue) ? [parsedValue] : []
  } catch (error) {
    return []
  }
}

function writeCachedLogs(entries) {
  const uniqueEntries = []
  const knownKeys = new Set()
  entries.forEach(entry => {
    if (!isLogEntry(entry)) return
    const key = entry.id !== undefined && entry.id !== null
      ? `id:${entry.id}`
      : `${entry.source}|${entry.time}|${entry.content}`
    if (knownKeys.has(key)) return
    knownKeys.add(key)
    uniqueEntries.push(entry)
  })

  try {
    sessionStorage.setItem(LOG_CACHE_KEY, JSON.stringify(uniqueEntries.slice(-MAX_CACHED_LOGS)))
  } catch (error) {
    // 缓存写入失败不影响日志页和后端日志请求。
  }
}
